import { render, staticRenderFns } from "./BranchDeliveryCosts.vue?vue&type=template&id=6d2ec9b0&scoped=true&"
import script from "./BranchDeliveryCosts.vue?vue&type=script&lang=js&"
export * from "./BranchDeliveryCosts.vue?vue&type=script&lang=js&"
import style0 from "./BranchDeliveryCosts.vue?vue&type=style&index=0&id=6d2ec9b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2ec9b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VDataTable,VTextField})
